import type { ReactNode } from "react";
import { ArrowUpRight } from "lucide-react";

export function Surface({ title, icon, action, children, className = "" }: { title: string; icon?: ReactNode; action?: { label: string; onClick(): void }; children: ReactNode; className?: string }) {
  return <section className={`surface ${className}`}>
    <header className="surface-header"><div className="surface-title">{icon && <span className="surface-icon">{icon}</span>}<h2>{title}</h2></div>{action && <button className="text-button" onClick={action.onClick}>{action.label}<ArrowUpRight size={15}/></button>}</header>
    {children}
  </section>;
}

export function StatusPill({ children, tone = "blue" }: { children: ReactNode; tone?: "blue" | "green" | "amber" | "gray" | "violet" }) {
  return <span className={`status-pill ${tone}`}><span className="status-dot"/>{children}</span>;
}

export function EmptyState({ icon, title, text, action }: { icon: ReactNode; title: string; text: string; action?: ReactNode }) {
  return <div className="empty-state"><div className="empty-icon">{icon}</div><h3>{title}</h3><p>{text}</p>{action}</div>;
}
